import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelMembershipsCommand, } from "../commands/ListChannelMembershipsCommand";
export const paginateListChannelMemberships = createPaginator(ChimeSDKMessagingClient, ListChannelMembershipsCommand, "NextToken", "NextToken", "MaxResults");
